import { useTheme } from "@mui/system";

export default function ResearchIcon({size = 40}) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 35;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg 
      width={baseWidth}
      height={height}
      viewBox="0 0 40 35" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M25.0153 16.5498L21.1327 24.315C20.664 25.2603 19.3047 25.229 18.8751 24.2681L14.43 14.4015L12.0864 20.0027H4.73526L18.9922 34.5722C19.5469 35.1425 20.4453 35.1425 20.9999 34.5722L35.2647 20.0027H26.7418L25.0153 16.5498ZM37.0068 3.27715L36.8193 3.08185C32.7961 -1.02728 26.2106 -1.02728 22.1796 3.08185L20 5.3161L17.8204 3.08966C13.7972 -1.02728 7.20387 -1.02728 3.18066 3.08966L2.99317 3.27715C-0.811292 7.16755 -0.975345 13.3625 2.4229 17.5029H10.4224L13.227 10.7689C13.6488 9.76115 15.0706 9.73772 15.5237 10.7377L20.0703 20.8386L23.8982 13.1906C24.3591 12.2688 25.6715 12.2688 26.1325 13.1906L28.2886 17.5029H37.5771C40.9753 13.3625 40.8113 7.16755 37.0068 3.27715Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>
  )
}